import { createStore } from 'vuex'
import router from "@/router";
import axios from "axios";
import createPersistedState from 'vuex-persistedstate';
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth } from "../main.js";

export default createStore({
  state: {
    userId: null,
    exhibitName: "",
    exhibitId: "",
    resourcesFromPoints: [],
    resourcesCount: 0,
    exhibitUrl: "",
    pointSelected: "",
    adminIds : [1, 3, 6, 405]
  },
  getters: {
    // Adresse de l'exposition courante, toujours sur l'origine du site ouvert.
    // `state.exhibitUrl` est persisté dans le navigateur : il peut encore
    // contenir une ancienne adresse (https://marc-antoine-lune.github.io/at-expo/…,
    // redirigée vers test.logexpobu.fr, bloqué à l'université). On n'en garde
    // que la route après « # », que l'on remet sur l'origine courante.
    exhibitUrl(state) {
      const url = state.exhibitUrl || "";
      const diese = url.indexOf("#");
      return diese === -1 ? url : `${window.location.origin}/${url.slice(diese)}`;
    },
  },
  mutations: {
    changeUserId(state, id) {
      state.userId = id
    },
    SET_USER(state, id) {
      state.userId = id;
    },
    SET_EXHIBITNAME(state, name){
      state.exhibitName = name;
    },
    SET_EXHIBITID(state, id){
      state.exhibitId = id;
    },
    SET_RESOURCESFROMPOINTS(state, resources){
      state.resourcesFromPoints = resources;
    },
    SET_RESOURCESCOUNT(state, count){
      state.resourcesCount = count;
    },
    SET_EXHIBITURL(state, url){
      state.exhibitUrl = url;
    },
    SET_POINTSELECTED(state, point){
      state.pointSelected =  point;
    },
    RESET_EXHIBIT_DATA(state) {
      state.resourcesFromPoints = [];
      state.resourcesCount = 0;
      state.exhibitUrl = "";
      state.pointSelected = "";
    }


  },
  actions: {
    // Les erreurs remontent telles quelles : la page de connexion lit leur
    // `code` (auth/invalid-credential, auth/too-many-requests…) pour afficher
    // un message précis. Les envelopper dans un nouvel Error effaçait ce code.
    async signInAction({ commit }, form) {
      const userCredential = await signInWithEmailAndPassword(auth, form.email, form.password);

      // Le compte Firebase doit correspondre à un utilisateur LogExpo.
      const url = `${process.env.VUE_APP_BASEURL}/userfromuuid/${userCredential.user.uid}`;
      const response = await axios.get(url);
      const utilisateur = response.data && response.data[0];
      if (!utilisateur) {
        // Pas de session Firebase à moitié ouverte : on referme.
        await signOut(auth);
        const erreur = new Error("Compte Firebase sans utilisateur LogExpo");
        erreur.code = 'logexpo/utilisateur-inconnu';
        throw erreur;
      }

      commit('SET_USER', utilisateur.id);
      await router.push('/admin/');
    }
  },
  modules: {
  },
  plugins: [createPersistedState()]

})
